// =============================
// Email: info@xx.com
// www.xx.com/templates
// =============================

export class User {
  // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type
  constructor(id?: string, userName?: string, fullName?: string, email?: string, jobTitle?: string, phoneNumber?: string, roles?: string[], sfid?: string, hid?: string, mfaEnabled?: boolean){

    this.id = id;
    this.userName = userName;
    this.fullName = fullName;
    this.email = email;
    this.jobTitle = jobTitle;
    this.phoneNumber = phoneNumber;
    this.roles = roles
    this.sfid = sfid
    this.hid = hid,
    this.mfaEnabled = mfaEnabled ?? false; 
  }

  get friendlyName(): string {
    let name = this.fullName || this.userName;

    if (this.jobTitle) {
      name = this.jobTitle + ' ' + name;
    }

    return name;
  }


  public id: string;
  public userName: string;
  public fullName: string;
  public email: string;
  public jobTitle: string;
  public phoneNumber: string;
  public isEnabled: boolean;
  public isLockedOut: boolean;
  public roles: string[];
  public sfid: string;
  public hid: string;
  public mfaEnabled: boolean;

}


export class SFLogin  {
  constructor(username?: string, password?: string) {
    
    this.username = username;
    this.password = password; 
  }

  public username: string;
  public password: string; 
}

